module.exports = __webpack_public_path__ + "img/about1.1ee0f81d.png";